import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Locale from "../../locales";
import { updateTeacherMessage } from "../../redux/actions";
import "./TeacherMessage.css";

const useStyles = makeStyles({
  selectStudentControl: {
    width: "100%",
  },
  message: {
    width: "100%",
  },
  syncBuuton: {
    marginRight: "25px",
  },
});

const TeacherMessage = () => {
  const loading = useSelector((state) => state.adminReducer.loading);
  const teachers = useSelector((state) => state.adminReducer.teachers);
  const [selectedTeacher, setSelectedTeacher] = useState("");
  const [currentTeacherMessage, setCurrentTeacherMessage] = useState("");
  const styles = useStyles();
  const dispatch = useDispatch();

  const handleTeacherChange = (event) => {
    setSelectedTeacher(event.target.value);
    const currentTeacher = teachers.find(
      (teacher) => teacher.emailId === event.target.value,
    );
    setCurrentTeacherMessage(currentTeacher.teacherMessage);
  };

  const handleTeacherMessageChange = (event) => {
    setCurrentTeacherMessage(event.target.value);
  };

  const submitChangedMessage = (event) => {
    event.preventDefault();
    const data = {
      teacherId: selectedTeacher,
      teacherMessage: currentTeacherMessage,
    };
    dispatch(updateTeacherMessage(data));
  };

  return (
    <div className="create-teacher-message-container">
      <div className="teacher-message-list-heading-container">
        <h1 className="teacher-message-list-header-text">
          {Locale.t("create_teacher_message")}
        </h1>
      </div>
      <form className="teacher-message-form" onSubmit={submitChangedMessage}>
        <div className="teacher-message-list-section-container">
          <FormControl
            disabled={loading}
            className={styles.selectStudentControl}>
            <InputLabel id="select-range">
              {Locale.t("select_a_teacher")}
            </InputLabel>
            <Select
              labelId="select-range-label"
              id="select-range"
              value={selectedTeacher}
              label={Locale.t("select_a_teacher")}
              onChange={handleTeacherChange}>
              {teachers.map((teacher) => (
                <MenuItem key={teacher.emailId} value={teacher.emailId}>
                  {teacher.emailId}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="teacher-form-content-container">
          <FormControl className={styles.message}>
            <TextField
              multiline
              minRows={4}
              value={currentTeacherMessage}
              onChange={handleTeacherMessageChange}
              label={Locale.t("Message")}
              required
            />
          </FormControl>
        </div>
        <div className="teacher-message-submit-button-container">
          <Button
            disabled={loading}
            style={{ margin: "auto" }}
            type="submit"
            size="large"
            variant="contained">
            {Locale.t("update_message")}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default TeacherMessage;
